import React from 'react'
import { CoreContainer } from '@hub/core-container'
import { Box } from '@hub/box'
import { Grid } from '@hub/grid'
import { Text } from '@hub/text'
import { HubResponsiveValue, As } from '@hub/design-system-base'
import { CloudinaryImage } from '../cloudinary-image'
import { SGPageTemplateContentEntry } from '../../../types/page-templates'
import TileLink from '../tile-list/tile-link'

type Props = {
  items: (SGPageTemplateContentEntry & { as?: As })[]
  iconHeight?: HubResponsiveValue<string>
}

function UtilityPanel({
  items,
  iconHeight = 'size-icon-md',
}: Props): JSX.Element {
  return (
    <CoreContainer>
      <Box align="center">
        <Grid
          templateColumns={[
            'repeat(auto-fit, 45%)',
            'repeat(auto-fit, 30%)',
            'repeat(auto-fit, 24.1%)',
            'repeat(auto-fit, 19.3%)',
            'repeat(auto-fit, 16%)',
          ]}
          templateRows={'1fr, 1fr, 1fr'}
          gap={['spacing-sm']}
          sx={{
            justifyContent: 'center',
            alignItems: 'stretch',
            gridAutoRows: '1fr',
            justifyItems: 'stretch',
          }}
        >
          {items.map((entry, i) => (
            <TileLink key={i} url={entry.callToAction.url} as={entry.as}>
              <CloudinaryImage
                ratio="1"
                imageSetOrImage={{
                  type: 'SQUARE',
                  url: entry.image.url,
                  alt: entry.image.alt || entry.title,
                }}
                sx={{ boxSize: iconHeight }}
              />
              <Text
                isBodyText
                align="center"
                tone="strong"
                sx={{ marginTop: 'spacing-sm' }}
              >
                {entry.title}
              </Text>
            </TileLink>
          ))}
        </Grid>
      </Box>
    </CoreContainer>
  )
}

export default UtilityPanel
